export const engagementPredictionAppGroupData = "/engagement/prediction_app_group_data";
